import { render, staticRenderFns } from "./_no-access.vue?vue&type=template&id=7e2b9a54&scoped=true"
import script from "./_no-access.vue?vue&type=script&lang=js"
export * from "./_no-access.vue?vue&type=script&lang=js"
import style0 from "./_no-access.vue?vue&type=style&index=0&id=7e2b9a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2b9a54",
  null
  
)

export default component.exports